module.exports = __webpack_public_path__ + "img/DSC_0103.cfb5b701.jpg";